import { errorToast } from "@/v2-ui/toast"
import { useCustomerMultiSessionMutation } from "@/v2-backoffice-client/customer/multiSession/customer.multiSession.mutation"
import ActionMenu from "@/v2-backoffice-client/components/actionMenu"

export type CustomerMultiSessionMenuProps = {
  customerId: number
  onCompleted?(): void
}

function CustomerMultiSessionMenu(props: CustomerMultiSessionMenuProps) {
  const { customerId, onCompleted } = props

  const [setMultiSession, { loading, error }] =
    useCustomerMultiSessionMutation()
  errorToast(error, { title: "Failed to update multi-session exemption" })

  return (
    <ActionMenu>
      <ActionMenu.Trigger
        isStacked
        iconSrc="devices"
        content="Exempt every user of this customer from the single-active-session limit, or re-subject them to it."
      >
        Multi-Session
      </ActionMenu.Trigger>

      <ActionMenu.Content>
        <ActionMenu.Label>Multi-Session</ActionMenu.Label>
        <ActionMenu.Separator />

        <ActionMenu.ConfirmItem
          iconSrc="unlock"
          variant="success"
          content="Exempt every user of this customer from the single-active-session limit."
          confirmDescription="Allow multi-session for all users of this customer?"
          confirmVariant="success"
          isLoading={loading}
          onConfirm={() => {
            setMultiSession({
              variables: { customerId, allowed: true },
              onCompleted,
            })
          }}
        >
          Allow for all users
        </ActionMenu.ConfirmItem>

        <ActionMenu.ConfirmItem
          iconSrc="lock"
          variant="warning"
          content="Re-subject every user of this customer to the single-active-session limit."
          confirmDescription="Disallow multi-session for all users of this customer?"
          confirmVariant="warning"
          isLoading={loading}
          onConfirm={() => {
            setMultiSession({
              variables: { customerId, allowed: false },
              onCompleted,
            })
          }}
        >
          Disallow for all users
        </ActionMenu.ConfirmItem>
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default CustomerMultiSessionMenu
